export const normalizeString = (value: string): string => {
  return value.replace(/\s+/g, ' ').trim();
};

export const removeWhiteSpaces = (value: string): string => {
  return value.replace(/\s/g, '');
};
